import { ReactElement } from 'react';
import renderer from 'react-test-renderer';

export function persistContent(root: ReactElement) {
    return JSON.stringify(renderer.create(root).toJSON());
}